module.exports = __webpack_public_path__ + "static/media/modal-robo-de-lances-comprasnet.caad92ec.png";